import { render, staticRenderFns } from "./salelist.vue?vue&type=template&id=fad6084e&scoped=true&"
import script from "./salelist.vue?vue&type=script&lang=js&"
export * from "./salelist.vue?vue&type=script&lang=js&"
import style0 from "./salelist.vue?vue&type=style&index=0&id=fad6084e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad6084e",
  null
  
)

export default component.exports